/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import config from '@/const/config';
import request from './xhr';
var switchApi = config.switchApi;
/**
 * 获取开城配置
 * @param {Object} param body
 */

export function getPowerConfig(params) {
  // return Promise.resolve({
  //   redirectColor: 'red',
  //   pageConfig: [{
  //     order: 1,
  //     type: 1,
  //     picture: '11',
  //   }]
  // });
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.city.preheat.config'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 是否开城
 * @param {*} params
 */

export function powerIsOpen(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.city.open.biz'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 收集联系方式
 * @param {*} params
 */

export function addcopartner(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.city.preheat.addcopartner'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 是否存在联系方式
 * @param {*} params
 */

export function isexistcopartner(params) {
  // return Promise.resolve(false);
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.city.preheat.isexistcopartner'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 获取用户实名信息
 * @param {*} params
 */

export function getUserRealinfo() {
  // return Promise.resolve({
  //   realName: '323', mobile: '2323'
  // });
  return request.post(switchApi, {
    action: 'switchpower.user.find.realname'
  }).then(function (res) {
    return res.data;
  });
}